import httpClient from './http-client';

export default class LocationService {
    private baseApiEndpoint = '/api/locs';
    private userGuid: string;
    private gdmNumber: string;

    constructor(
        userGuid: string, 
        gdmNumber: string, 
        idToken?: string | undefined, 
        accessToken?: string | undefined
    ) {
        this.userGuid = userGuid;
        this.gdmNumber = gdmNumber;
        this.baseApiEndpoint = import.meta.env.VITE_BYPASS_PROXY === 'true' 
                                ? '' : this.baseApiEndpoint;
    }

    async getAllByGdmNumber(): Promise<any> {
        let response
        try {
            response = await httpClient.get(
                `${this.baseApiEndpoint}/locations?gdm_customer_number=${this.gdmNumber}&requestId=${new Date().getTime().toString()}`,
                {
                    headers: {
                        // 'X-Authorization': `Bearer ${this.accessToken}`,
                    },
                }
            );
        } catch (error) {
            console.error('Error fetching locations:', error);
            throw error;
        }
        
        return response?.data || null;
    }

    async createLocation(name: string, parentId?: string | null): Promise<any> {
        let response
        try {
            const payload = {
                name,
                gdm_customer_number: this.gdmNumber,
                parent_id: parentId
            };

            response = await httpClient.post(
                `${this.baseApiEndpoint}/locations?user_guid=${this.userGuid}`,
                payload,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json',
                        // 'X-Authorization': `Bearer ${this.accessToken}`,
                    },
                }
            );
        } catch (error) {
            console.error('Error creating location:', error);
            throw error;
        }
        
        return response?.data || null;
    }

    async renameLocation(locationId: string, name: string): Promise<any> {
        let response
        try {
            response = await httpClient.post(
                `${this.baseApiEndpoint}/locations/${locationId}?user_guid=${this.userGuid}`,
                { name },
                {
                    headers: {
                        'Content-Type': 'application/json',
                        // 'X-Authorization': `Bearer ${this.accessToken}`,
                    },
                }
            );
        } catch (error) {
            console.error('Error renaming location:', error);
            throw error;
        }
        
        return response?.data || null;
    }

    async updateHierarchy(locationId: string, operationType: string, targetLocationId: string): Promise<any> {
        let response
        try {
            response = await httpClient.post(
                `${this.baseApiEndpoint}/locations/${locationId}/update-hierarchy?user_guid=${this.userGuid}`,
                {
                    operation_type: operationType,
                    target_location_id: targetLocationId
                },
                {
                    headers: {
                        'Content-Type': 'application/json',
                        // 'X-Authorization': `Bearer ${this.accessToken}`,
                    },
                }
            );
        } catch (error) {
            console.error('Error updating location hierarchy:', error);
            throw error;
        }
        
        return response?.data || null;
    }

    async deleteLocation(locationId: string): Promise<any> {
        let response
        try {
            response = await httpClient.delete(
                `${this.baseApiEndpoint}/locations/${locationId}?user_guid=${this.userGuid}`,
                {
                    headers: {
                        // 'X-Authorization': `Bearer ${this.accessToken}`,
                    },
                }
            );
        } catch (error) {
            console.error('Error deleting location:', error);
            throw error;
        }
        
        return response?.data || null;
    }
}


